import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import FullScreenIframe from '@components/home/FullScreenIframe';
import { useNavigate, useLocation } from 'react-router-dom';
import { SWITCH_ROUTES } from '@constants/routes';
import { useGlobalProps } from '@hooks/useGlobalProps';

export default function GamePage() {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, getBalance, setGameDisplaying } = useGlobalProps();

    const [gameUrl, setGameUrl] = useState(null);
    const isCasinoRef = useRef(false);

    const handleDismiss = () => {
        // For casino games, return to home with flag to reopen seat modal
        if (isCasinoRef.current) {
            navigate(SWITCH_ROUTES.ROOT, {
                state: { reopenCasinoSeat: true, casinoGame: location.state?.casinoGame }
            });
        } else {
            navigate(SWITCH_ROUTES.ROOT);
        }
    };

    useEffect(() => {
        if (location.state && location.state.gameUrl) {
            setGameDisplaying(true);
            setGameUrl(location.state.gameUrl);
            isCasinoRef.current = !!location.state.isCasino;
        }

        const handleMessage = async (message) => {
            if (message.data) {
                try {
                    const data = JSON.parse(message.data);
                    if (data && !!data.IsCloseGame) {
                        setGameDisplaying(false);
                        // For casino games, return to home with flag to reopen seat modal
                        if (isCasinoRef.current) {
                            navigate(SWITCH_ROUTES.ROOT, {
                                state: { reopenCasinoSeat: true, casinoGame: location.state?.casinoGame }
                            });
                        } else {
                            navigate(SWITCH_ROUTES.ROOT);
                        }
                    }
                } catch (error) { }
            }
        };

        window.addEventListener('message', handleMessage, false);

        return () => {
            window.removeEventListener('message', handleMessage);
            setGameDisplaying(false);
            if (user?.ukey) getBalance();
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <GamePageWrap>
            {gameUrl != null && (
                <FullScreenIframe url={gameUrl} onDismiss={handleDismiss} />
            )}
        </GamePageWrap>
    );
}

const GamePageWrap = styled.div`
    width: 100%;
`;
